<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มกะทำงาน</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ shiftInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ shiftInit.title_en }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          รหัสกะทำงาน
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="shift.shift_code"
          :rules="[
            (v) => !!v || 'โปรดระบุรหัสกะทำงาน',
            (v) =>
              (v && v.length >= 1 && v.length <= 32) ||
              'รหัสกะทำงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'shift_code')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          กะทำงาน
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="shift.title_th"
          :rules="[
            (v) => !!v || 'โปรดระบุกะทำงาน',
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'กะทำงานต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2"> กะทำงาน (อังกฤษ) </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="shift.title_en"
          :rules="[
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'กะทำงานต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <v-dialog
          ref="dialogTimeIn"
          v-model="modalTimeIn"
          :return-value.sync="shift.time_in"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div>
              <label class="body-2">
                เวลาเข้างาน
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                tabindex="4"
                v-model="shift.time_in"
                append-icon="mdi-clock-outline"
                @click:append="modalTimeIn = true"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="[(v) => !!v || 'โปรดระบุเวลาเข้างาน']"
                outlined
                dense
              >
              </v-text-field>
            </div>
          </template>
          <v-time-picker
            v-if="modalTimeIn"
            v-model="shift.time_in"
            full-width
            format="24hr"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalTimeIn = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialogTimeIn.save(shift.time_in)"
              >ตกลง
            </v-btn>
          </v-time-picker>
        </v-dialog>
        <v-dialog
          ref="dialogTimeOut"
          v-model="modalTimeOut"
          :return-value.sync="shift.time_out"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div>
              <label class="body-2">
                เวลาออกงาน
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                tabindex="5"
                v-model="shift.time_out"
                append-icon="mdi-clock-outline"
                @click:append="modalTimeOut = true"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="[(v) => !!v || 'โปรดระบุเวลาออกงาน']"
                outlined
                dense
              >
              </v-text-field>
            </div>
          </template>
          <v-time-picker
            v-if="modalTimeOut"
            v-model="shift.time_out"
            full-width
            format="24hr"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalTimeOut = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialogTimeOut.save(shift.time_out)"
              >ตกลง
            </v-btn>
          </v-time-picker>
        </v-dialog>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isShiftDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::shift:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::shift:create')"
            tabindex="6"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::shift:update')"
            tabindex="6"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn tabindex="7" depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    shift: {
      type: Object,
    },
    shiftInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      modalTimeIn: false,
      modalTimeOut: false,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isShiftDataChange() {
      if (
        this.shift.shift_code !== this.shiftInit.shift_code ||
        this.shift.title_th !== this.shiftInit.title_th ||
        this.shift.title_en !== this.shiftInit.title_en ||
        this.shift.time_in !== this.shiftInit.time_in ||
        this.shift.time_out !== this.shiftInit.time_out
      ) {
        this.$emit('isShiftDataChange', true)
        return true
      }
      this.$emit('isShiftDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      addShift: 'shift/addShift',
      editShift: 'shift/editShift',
      deleteShift: 'shift/deleteShift',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.shift[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบกะทำงาน',
        value: this.shift.title_th,
        item: this.shift,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(shift) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteShift({
        companyUUID: company_uuid,
        shiftUUID: shift.shift_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        if (!this.shift.title_en) {
          this.shift.title_en = null
        }

        const { company_uuid } = this.$store.state.authentication.company

        this.addShift({
          companyUUID: company_uuid,
          shift: this.shift,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        this.editShift({
          companyUUID: company_uuid,
          shiftUUID: this.shift.shift_uuid,
          shift: this.shift,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isShiftDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
        // this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.resetValidation()
        // this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
